import type { ChangeEvent, FocusEvent } from "react";
import { useEffect, useState } from "react";

interface AlphaInputProps {
  onChange: (val: number) => void;
  value?: number;
}

export const AlphaInput = ({ value = 100, onChange }: AlphaInputProps) => {
  const [displayValue, setDisplayValue] = useState(`${value}%`);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setDisplayValue(`${value}%`);
    }
  }, [value, isFocused]);

  const handleFocus = (e: FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    setDisplayValue(e.target.value.replace("%", ""));
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    let val = parseFloat(e.target.value);

    if (isNaN(val)) {
      val = value;
    } else {
      val = Math.max(0, Math.min(100, val));
    }

    setDisplayValue(`${val}%`);
    onChange(val);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(e.target.value);
  };

  return (
    <input
      type="text"
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      className="border-primary bg-primary text-dark group-hover:border-darkest focus:border-darkest group-focus-within:border-darkest w-full rounded-lg border px-2 py-1 text-center [appearance:textfield] focus:!outline-none focus:!ring-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
    />
  );
};
